// validator-registry.js
export class ValidatorRegistry {
    constructor() {
        this._validators = new Map();
    }

    register(name, validatorInstance) {
        this._validators.set(name, validatorInstance);
        return this; // For chaining
    }

    get(name) {
        if (!this._validators.has(name)) {
            throw new Error(`Validator "${name}" not found`);
        }
        return this._validators.get(name);
    }

    has(name) {
        return this._validators.has(name);
    }
}

// Create and export a singleton instance
export const validatorRegistry = new ValidatorRegistry();
